{
  "COMPONENTS": {
    "MAIN_APP_BAR": {
      "LOGO": "Mankiewicz"
    },
    "MAIN_FOOTER": {
      "LINKS": {
        "IMPRINT": {
          "LABEL": "Imprint",
          "URL": "https://www.mankiewicz.com/en/imprint"
        },
        "DATA_PROTECTION": {
          "LABEL": "Privacy Policy",
          "URL": "https://www.mankiewicz.com/en/privacy-policy"
        },
        "COOKIE_SETTINGS": {
          "LABEL": "Cookie Settings"
        }
      }
    },
    "LOGOUT_BUTTON": {
      "LABEL": "Logout"
    },
    "LOGIN_BUTTON": {
      "LABEL": "Sign in"
    },
    "LANGUAGE_SWITCH": {
      "LABEL": "Change language",
      "DIALOG": {
        "TITLE": "Select language",
        "SAVE": "Save",
        "CANCEL": "Cancel"
      }
    },
    "FLAG_ICON": {
      "ARIA_LABEL": "Flag for {locale}"
    },
    "FILTER_MENU": {
      "TITLE": "Filter",
      "TOGGLE_BUTTON": "Filter",
      "CLOSE_BUTTON_TOP_LABEL": "Close filter",
      "CLOSE_BUTTON_BOTTOM_LABEL": "Apply filter"
    },
    "HEADER": {
      "RESET_BUTTON": "Reset all filters",
      "RESET_DOCUMENTS_SELECTION_BUTTON": "Reset documents selection"
    },
    "MAIL_RECIPIENTS_INPUT": {
      "LABEL": "Recipients",
      "PLACEHOLDER": "Please provide email address(es)",
      "MESSAGE": "Example: \"name{'@'}example.com\""
    }
  },
  "VIEWS": {
    "PUBLIC": {
      "ERROR_PAGE": {
        "TITLE": "There was an Error",
        "MESSAGE": "Sorry, something went wrong. Please try again later.",
        "BUTTON_BACK_LABEL": "Back",
        "BUTTON_HOME_LABEL": "Home"
      },
      "PAGE_NOT_FOUND": {
        "TITLE": "Page not found",
        "MESSAGE": "Unfortunately, the page you requested could not be found.",
        "BUTTON_BACK_LABEL": "Back",
        "BUTTON_HOME_LABEL": "Home"
      },
      "PAGE_NOT_ALLOWED": {
        "TITLE": "Access denied",
        "MESSAGE": "You do not have access to the page you requested.",
        "BUTTON_BACK_LABEL": "Back",
        "BUTTON_HOME_LABEL": "Home"
      }
    },
    "RESTRICTED": {
      "LOGIN_ERROR": {
        "TITLE": "Sign-in not possible",
        "MESSAGE": "The authentication server is currently unreachable. Please check your internet connection and try again.",
        "BUTTON_RETRY_LABEL": "Try again"
      },
      "DOCUMENT_LIST": {
        "HEADER": {
          "DOWNLOAD_DOCUMENTS_BUTTON": {
            "LABEL": "Download/Mail Selection ({count})",
            "LIMIT_MESSAGE": "You have selected {count} of maximum {max} documents."
          }
        },
        "RESULTS": {
          "TABLE_HEADERS": {
            "PRODUCT_NAME": "Product name",
            "IS_NEW": "",
            "PRODUCT_NUMBER": "Product number",
            "PRODUCT_PART_NUMBER": "Part number",
            "DESCRIPTION": "Description",
            "LEGAL_AREA": "Legal area",
            "LANGUAGE": "Language",
            "TYPE": "Type",
            "ACTIONS": "Download"
          },
          "TABLE_FOOTER": {
            "TOTAL_COUNT": "No results | One Result | {count} Results",
            "NEXT_PAGE": "Next page",
            "PREVIOUS_PAGE": "Previous page",
            "ITEMS_PER_PAGE": "Items per page",
            "CURRENT_PAGE": "Page {currentPage} of {totalPages}"
          },
          "ITEM": {
            "IS_NEW": "New",
            "DOWNLOAD_ERROR_TOOLTIP": "Download failed. Please try again."
          }
        },
        "FILTER": {
          "COMMON": {
            "TITLE": "Filter",
            "PLACEHOLDER": "Select"
          },
          "TEXT_SEARCH": {
            "LABEL": "Product search",
            "PLACEHOLDER": "Search your product"
          },
          "LEGAL_AREA": {
            "LABEL": "Legal area"
          },
          "DOCUMENT_LANGUAGE": {
            "LABEL": "Document language"
          },
          "DOCUMENT_TYPE": {
            "LABEL": "Document type"
          },
          "PRODUCT_COLOR": {
            "LABEL": "Product color"
          },
          "PRODUCT_GLOSS_LEVEL": {
            "LABEL": "Gloss level"
          },
          "DOCUMENT_CREATION_DATE": {
            "LABEL": "Creation date"
          },
          "DOCUMENT_IS_NEW_FOR_CLIENT": {
            "LABEL": "Show new documents"
          }
        }
      },
      "DOCUMENTS_DOWNLOAD": {
        "BUTTON_LABEL_DOCUMENT_SELECTION": "Back To Document Search",
        "LIST": {
          "HEADLINE": "Hello {name} - You have selected {count} documents.",
          "TEXT": "The selected documents have been bundled into a ZIP file. The download link is valid for 24 hours.",
          "BACK_BUTTON": {
            "LABEL": "Back to Selection"
          },
          "MAIL_BUTTON": {
            "LABEL": "Send by Mail"
          },
          "DOWNLOAD_BUTTON": {
            "LABEL": "Download {fileSize} MB"
          }
        },
        "SEND_MAIL": {
          "TITLE": "Enter additional recipients to send the download link to others.",
          "SEND_BUTTON": {
            "LABEL": "Send"
          },
          "GO_BACK_BUTTON": {
            "LABEL": "Back"
          }
        },
        "SEND_MAIL_SUCCESS": {
          "TITLE": "Hello {name},\nYour selection was successfully sent.",
          "TEXT": "The ZIP file with the selected documents will be delivered shortly\nto your email address and all specified recipients."
        },
        "SEND_MAIL_FAILURE": {
          "TITLE": "Hello {name},\nYour selection could not be sent.",
          "TEXT": "An error occurred while sending the ZIP file with the selected documents.\nPlease try again later.",
          "GO_BACK_BUTTON": {
            "LABEL": "Try again"
          }
        }
      }
    }
  },
  "validations": {
    "required": "Please fill out!",
    "email": "Please enter a valid email address",
    "maxLength": "Please do not enter more than {max} characters",
    "minLength": "Please do not enter fewer than {min} characters",
    "integer": "Please enter numbers only",
    "requiredIf": "Please fill out!",
    "emailArray": "Please provide valid email addresses",
    "customerExists": "A customer with this customer number already exists"
  }
}